import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { parsePermalink } from "shared/Permalinks";
import { resolvePermalink } from "src/server/functions/Permalinks";

// Permalinks (`/go/<type>/<id>`, shared/Permalinks.ts): links sent out of the app (webhooks, emails,
// connector messages) that open an item wherever the portal keeps it now. A signed-in visitor who
// may open the item is redirected to its page; signed out, the sign-in page shows here and the
// link runs again once they're in; anything else is not found, the same whether the item exists.
export const Route = createFileRoute("/_authed/go/$")({
  loader: async ({ location }) => {
    const link = parsePermalink(`${location.pathname}${location.searchStr}`);
    if (!link) throw notFound();
    const resolved = await resolvePermalink({ data: { type: link.type, id: link.id } });
    if ("path" in resolved)
      throw redirect({
        href: `${resolved.path}${link.page}${link.search}`,
        statusCode: 302,
        headers: { "Cache-Control": "no-store" },
        replace: true,
      });
    if (resolved.state === "not-found") throw notFound();
    return null;
  },
  // Signed out, the `_authed` layout shows the sign-in page in place of this.
  component: () => null,
});
